import { apiRequest,userAppApiRequest } from './apiWrapper'
import { API_END_POINT } from '../utils/constants/apiEndPoints'

export async function userJourneyApi(payload) {
    const response = await apiRequest({
        method: "post",
        url: API_END_POINT.userJourneyAnalytics,
        data: payload,
    });

    return response;
}

export async function userRegisterApi(payload) {
    const response = await apiRequest({
        method: "post",
        url: API_END_POINT.userRegisterAnalytics,
        data: payload,
    });

    return response;
}

export async function userSearchApi(payload) {
    const response = await apiRequest({
        method: "post",
        url: API_END_POINT.userSearchAnalytics,
        data: payload,
    });

    return response;
}


export async function userAnalyticsEventApi(data) {
    const response = await userAppApiRequest({
        method: 'post',
        url: API_END_POINT.analyticsEvents,
        data
    })
    return response;
}

export async function userSubscriptionAnalytics(data) {
    const response = await userAppApiRequest({
        method: 'post',
        url: API_END_POINT.subscriptionAnalytics,
        data
    })
    return response;

}

export async function contentTrackAnalytics(data){
     const response = await userAppApiRequest({
        method: 'post',
        url: API_END_POINT.trackAnalytics,
        data
    })
    return response;
}

    export async function contentPlayerAnalytics(data){
     const response = await userAppApiRequest({
        method: 'post',
        url: API_END_POINT.playedAnalytics,
        data
    })
    return response;
}

    export async function playedMatricsAnalytics(data){
     const response = await userAppApiRequest({
        method: 'post',
        url: API_END_POINT.playerMatrics,
        data
    })
    return response;

}